import { Dialog } from "primereact/dialog";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ActionForm } from "./ActionForm";
import { useTranslation } from "react-i18next";
import LoadingDialog from "../Utils/LoadingDialog";
import { FarmContext } from "../../contexts/FarmContext";
import { validateSomething } from "../Form/Validations";
import { CostStep } from "./Services/Cost";
import { useNavigate, useOutletContext } from "react-router";
import { callSend } from "../Form/Form";
import RestAPI from "@aws-amplify/api-rest";
import { toast } from "react-toastify";
import PostState from "./PostState";
import { useLocation } from "react-router-dom";
import { formatPortsData } from "../Node/Node";
import { connections as farmTreeConnections, formatData } from "../../pages/Farms/Farms";
import { applyFormulas } from "../../utils/area";
import cloneDeep from "lodash/cloneDeep";

const AREA_FORMAT_KEY = "number.dec.4";
const AUTOGEST_ID = 9;
const JOHN_DEERE_ID = 134;
const defaultPrefijo = import.meta.env.VITE_DEFAULT_PREFIJO_CAMPO;
/**
 *
 * @param {{ dialogState: import('./types').DialogState }} param0
 */
const ActionDialog = ({ dialogState, setDialogState, connection,usuarioInfo, equipos, sectores}) => {
    const location = useLocation();
    const [dataSource, dispatch] = useContext(FarmContext);
    const getParams = (location) => {
        const params = new URLSearchParams(location && location.search);
        const farmId = params.get("farm") || params.get("farmblack");
        return { farmId };
    };
    const { farmId } = getParams(location);
    async function getDatos() {
        try {
            if (!farmId) return;
            const farmGeneral = `/farms/${farmId}/general`;
            const param = `/farms/${farmId}`;
            const fenologia = `/farms/${farmId}/plantillasFenologia`;
            const [newData, datosFarm, newFenologia] = await Promise.all([
                RestAPI.get("apiAdminDropControl", param).then((resultado) => {
                    if (Array.isArray(resultado && resultado.network) && Array.isArray(resultado.nodes)) {
                        resultado.network = resultado.network.filter((gwId) => {
                            if (gwId) return true;

                            // When there is no gateway, al nodes without modem are added
                            // as a child of a dummy node with nodo_id 0.
                            const gwIdx = resultado.nodes.findIndex(nodo => nodo.nodo_id === gwId);
                            if (gwIdx === -1) return false;
                            const gw = resultado.nodes[gwIdx];
                            resultado.nodes.splice(gwIdx, 1);

                            // If the dummy node has no children, remove it from network.
                            if ((!gw.childs || !gw.childs.length)) {
                                return false;
                            } else {
                                gw.nombre = "No Gateway";
                                gw.tipo = 0;
                            }
                            return true;
                        });
                    }

                    if (Array.isArray(resultado.nodes)) resultado.nodes.forEach(nodo => {
                        if (!nodo) return;
                        nodo.nombre = nodo.nombre && nodo.nombre.split("[")[0].trim();
                        const portsData = formatPortsData(nodo);
                        nodo.ports = portsData;
                        delete nodo.puertos_tarjetas_expansion;

                        const jerarquia = nodo.ports.hierarchy;
                        const datos = farmTreeConnections(jerarquia, resultado)[0];
                        nodo.data = datos;
                        const cantidadSensores = datos.tipoActuador.reduce((total, sensor) => {
                            return total + sensor.cantidad;
                        }, 0);
                        const cantidadActuadores = datos.tipoSensor.reduce((total, sensor) => {
                            return total + sensor.cantidad;
                        }, 0);
                        nodo.cantidad = cantidadSensores + cantidadActuadores;
                    });

                    if (Array.isArray(resultado.sectores) && resultado.areaInfo) {
                        const { formula_to_base: formula1, formula_from_kilo_base: formula2 } = resultado.areaInfo;
                        resultado.sectores.forEach(sector => {
                            if (sector && sector.superficie) {
                                // we can use formula2( formula1( sup / 10.000 ) )
                                // instead of formula2( formula1( sup ) / 10.000 ) for area
                                sector.superficie = applyFormulas(sector.superficie / 10000, formula1, formula2, AREA_FORMAT_KEY);
                            }
                        });
                    }

                    const areaInfo = resultado.areaInfo;
                    if (resultado.equipos) resultado.equipos.sort(({ nombre: a }, { nombre: b }) => (a < b) ? -1 : 1);
                    const origData = cloneDeep(resultado);
                    return { data: resultado, areaInfo, original: origData };
                }),
                RestAPI.get("apiAdminDropControl", farmGeneral).then((datosFarm) => {
                    if (datosFarm) datosFarm.mapa_json = datosFarm.mapa_json && JSON.parse(datosFarm.mapa_json);
                    if (!datosFarm.prefijo) datosFarm.prefijo = defaultPrefijo;
                    return datosFarm;
                }),
                RestAPI.get("apiAdminDropControl", fenologia).then(json => {
                    return json;
                }).catch(err => console.error(err))
            ]);
            if (newData) {
                newData.data = formatData(newData.data, newData.areaInfo, dataSource.users && dataSource.users.users, dataSource.sass && dataSource.sass.users,
                    datosFarm && datosFarm.mapa_json, datosFarm && datosFarm.huso_horario, datosFarm && datosFarm.can_edit, usuarioInfo && usuarioInfo.comercial);
                datosFarm.areaInfo = newData.areaInfo;
                delete newData.areaInfo;
            }
            datosFarm.fenologia = newFenologia?.plantillas;
            datosFarm.tiposRenovacion = newFenologia?.tiposRenovacion;
            datosFarm.paletasFenologia = newFenologia?.paletas;
            const newParams =  { loading: false, ...newData, dataFarm: datosFarm, users: dataSource.users, saas: dataSource.sass, formated: true };
            dispatch({ type: "set", params: newParams});
        } catch (err) {
            console.error("error", err);
        }
    }
    const { t, i18n } = useTranslation();
    const [forceLoading, setForceLoading] = useState(false);
    const [postState, setPostState] = useState(null);
    const agviewerCache = useRef({});
    const [{ dataFarm }, _] = useContext(FarmContext);
    const navigate = useNavigate();
    const { setReFetch } = useOutletContext() || {};

    useEffect(() => {
        setDialogState((prev) => {
            const reviewInputs = [{
                label: t("marketplace.acceptCostos"),
                campo: "accept_costos",
                component: "checkbox",
                validation: validateSomething
            }];
            if(connection?.marketplace_servicio_id ===14) {
                reviewInputs.unshift(
                    {
                        component: "info",
                        content: () => {
                            return (<>
                                <div className="col-12 col-md-12 text-md-rigth">
                                    <label >{t("marketplace.feature_soil")}</label>
                                    <label className='boldie ml-2'>{dataFarm.nombre}</label>
                                </div>
                            </>);
                        }
                    });
            }
            const preSteps = prev.steps?.map((s, id) => {
                if (id === 0) s.disabled = false;
                return s;
            });
            const steps = [
                ...prev.skipCostStep ? [] : [CostStep(t, connection)],
                ...preSteps,
                ...prev.skipReviewStep ? [] :[{
                    ...prev?.steps[prev.steps?.length - 1],
                    label: t("marketplace.review"),
                    inputs: [
                        ...(prev.steps?.[prev.steps?.length - 1]?.inputs.map(i => ({ ...i, edit: false })).filter(i => !i.notInReview) || []),
                        ...reviewInputs
                    ]
                }]
            ];
            const filteredSteps = steps.filter((obj, index, self) =>
                index === self.findIndex((t) => (
                    t.label === obj.label
                ))
            );
            return {
                ...prev,
                steps: [...filteredSteps]
            };
        });
    }, [connection, setDialogState, t]);

    const formikRef = useRef();
    const connect = async (values, props) => {
        try {
            // go to next step of the form
            if (dialogState.activeStep < dialogState.steps?.length - 1){
                setDialogState(s => ({
                    ...s,
                    steps: dialogState.steps,
                    activeStep: dialogState.activeStep + 1,
                    data: { ...s.data, ...values }
                }));
                return;
            }
            const { url, body, buy_seat } = dialogState.resolveBody(values, props);
            setForceLoading(true);
            const isEnabling = !connection.connection_data;
            if (buy_seat){
                await buySeatBeforeEnable(url, body, props.farmId);
            } else {
                sendForm(url, body, isEnabling);
            }
        } catch (error) {
            console.log(error);
            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            setForceLoading(false);
        }
    };

    const buySeatBeforeEnable = async (serviceUrl, serviceBody, farmId) => {
        await RestAPI.post("apiAdminDropControl", `/marketplace/${farmId}/enable-seat`, {
            body: { billing_servicio_id: 7 }
        });
        try {
            await RestAPI.post("apiAdminDropControl", serviceUrl, { body: serviceBody });
            toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            const newSearch = `?farm=${dataFarm.campo_id}`;
            setReFetch(true);
            navigate({ pathname: "/farms/marketplace", search: newSearch }, { state: { reFetch: true, activeTab: 1 } });
        } catch (error) {
            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            await RestAPI.post("apiAdminDropControl", `/marketplace/${farmId}/disable-seat`, {
                body: { billing_servicio_id: 7 }
            });
        }
    };

    const sendForm = (url, body, isEnabling) => {
        const setInfo = ({ data }) => {
            if (!isEnabling && connection.tipo_formulario === "SEAT" && data?.config?.cant > 0){
                dialogState.returnOnSuccess = false;
            }
            if (isEnabling || dialogState.returnOnSuccess){
                setPostState({state:"success", isEnabling:isEnabling});
                setForceLoading(false);
            }
            else if(!isEnabling && connection.marketplace_servicio_id === JOHN_DEERE_ID){
                setPostState({state:"success", isEnabling:isEnabling});
                setForceLoading(false);
            }
            else if(!isEnabling && connection.marketplace_servicio_id === AUTOGEST_ID){
                setPostState({state:"modifyTypeAccess", isEnabling:isEnabling, typeAccess:data.tipousuario_id});
                setReFetch(true);
                setForceLoading(false);
            }else {
                setReFetch(true);
                setForceLoading(false);
            }
            getDatos();
        };
        const setLoad = () =>{
            setForceLoading(false);
        };
        callSend(url, dialogState.oldData ?? {}, body, t, setInfo,undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,setLoad);
    };

    return (
        <>
            <Dialog
                id='mkt_enable_form'
                header={dialogState?.nombre_servicio}
                visible={dialogState?.visible}
                style={{ width: "50vw" }}
                onHide={() => setDialogState({ visible: false })}
                draggable={false}
                className='mkt-enable-dialog'
            >

                {forceLoading && <LoadingDialog extraClasses="fixMaxHeight" targetId="mkt_enable_form" /> }
                {postState?
                    <PostState connection={connection} state={postState.state} typeAccess={postState.typeAccess} isEnabling={postState.isEnabling} dialogState={dialogState} setDialogState={setDialogState} onClose={() => {
                        const newSearch = `?farm=${dataFarm.campo_id}`;
                        setReFetch(true);
                        navigate({ pathname: "/farms/marketplace", search: newSearch }, { state: { reFetch: true, activeTab: 1 } });
                    }}
                    />
                    :<div>
                        <ActionForm
                            innerRef={formikRef}
                            farmId={dataFarm?.campo_id}
                            dialogState={dialogState}
                            setDialogState={setDialogState}
                            connect={connect}
                            url={dialogState?.data?.url}
                            setForceLoading={setForceLoading}
                            unit={dataFarm?.areaInfo?.centi_unidad}
                            t={t}
                            i18n={i18n}
                            timezone={dataFarm?.huso_horario}
                            agviewerCache={agviewerCache}
                            equipos={equipos}
                            sectores={sectores}
                        />
                    </div>}
            </Dialog>
        </>
    );
};

export default ActionDialog;
